export default __webpack_public_path__ + "static/1_KV iMedical Card Elite 390px 430px BM-21c26f97a81709eeef25c0163027162b.jpg";